<template>
  <UMain :ui="{ base: ['w-dvw h-dvh'] }">
    <div :class="['grid lg:grid-cols-[1fr_32rem]', 'size-full overflow-hidden', 'relative']">
      <!-- 左侧图像容器 -->
      <div :class="['lg:block hidden', 'size-full', 'relative ', 'bg-primary/20']">
        <NuxtImg
          src="/img/bg/home-1.avif"
          draggable="false"
          alt="Crystal Network Background"
          fit="cover"
          :class="['absolute inset-0 size-full object-cover']"
        />
      </div>

      <!-- 右侧登录表单容器 -->
      <div
        :class="[
          'relative',
          'shadow-2xl',
          'flex flex-col justify-center items-center',
          'size-full',
          'lg:p-8 p-6',
        ]"
      >
        <!-- 顶部工具栏容器 -->
        <div
          :class="['absolute top-0 left-0', 'flex justify-between items-center', 'w-full', 'p-4']"
        >
          <!-- 左侧小容器 -->
          <div :class="['flex gap-2']">
            <!-- 回去登录按钮 -->
            <UButton
              v-if="!isLoginPage"
              icon="fe:arrow-left"
              variant="ghost"
              size="xl"
              @click="useLocalePush('/login')"
            />
            <!-- 回首页按钮 -->
            <UButton
              icon="mdi:home-outline"
              variant="ghost"
              size="xl"
              @click="useLocalePush('/')"
            />
          </div>

          <!-- 右侧小容器 -->
          <div :class="['flex gap-2']">
            <!-- 语言切换按钮 -->
            <UDropdownMenu
              :items="localeMap"
              :modal="false"
              :content="{
                align: 'center',
                side: 'bottom',
                sideOffset: 0,
              }"
            >
              <UButton :icon="i18nLableConfig[locale].icon" variant="ghost" size="xl" />
            </UDropdownMenu>
          </div>
        </div>

        <!-- logo -->
        <NuxtImg
          src="/img/logo/cnl-480x248.png"
          draggable="false"
          :class="['lg:w-32 w-28', 'lg:mb-10 mb-8']"
        />

        <!-- ❗实际页面内容 -->
        <slot />

        <!-- 背景容器 -->
        <div :class="['absolute z-[-1]', 'size-full', 'bg-default']">
          <div :class="['relative', 'size-full']">
            <!-- 渐变圆背景1 -->
            <div
              :class="[
                'absolute -top-1/2 -left-1/2',
                'size-400 rounded-full',
                'bg-[radial-gradient(circle_at_center,#f68f1e40_0%,#f68f1e20_20%,transparent_60%,transparent_80%,transparent_100%)]',
              ]"
            />

            <!-- 渐变圆背景2 -->
            <div
              :class="[
                'absolute -bottom-1/2 -right-1/2',
                'size-400 rounded-full',
                'bg-[radial-gradient(circle_at_center,#c4123040_0%,#c4123020_20%,transparent_60%,transparent_80%,transparent_100%)]',
              ]"
            />
          </div>
        </div>
      </div>
    </div>
  </UMain>
</template>

<script lang="ts" setup>
  import type { DropdownMenuItem } from '@nuxt/ui'

  const { locale, locales, setLocale } = useI18n()
  const { formatPathDot } = useI18nTools()
  /** 格式化后的当前路由名称 */
  const curRouteName = formatPathDot()
  const isLoginPage = curRouteName.value === 'login'

  /** 获取所有除了当前语言之外的当前语言完整数据 */
  const getOtherLocaleData = locales.value.filter(i => i.code !== locale.value)

  /** 将nuxt.config.ts文件定义的i18n数据转换为用于组件展示的数据对象 */
  const localeMap = computed<DropdownMenuItem[][]>(() => {
    return [
      getOtherLocaleData.map(curLocale => ({
        label: i18nLableConfig[curLocale.code].label,
        icon: i18nLableConfig[curLocale.code].icon,
        onSelect() {
          setLocale(curLocale.code)
        },
      })),
    ]
  })
</script>
